<template>
  <div>
    <div class="container vertical-align login escolha mt-4 text-center">
      <div class="row">
        <form @submit.prevent="" class="form-signin">
          <div>
            <div v-if="!this.celular || !this.email">
              <h1>Agora vamos verificar o seu {{ validationMethodText }}</h1>
              <h4>
                Enviaremos um código de validação para o endereço abaixo.
              </h4>
            </div>
            <div v-else>
              <h1>Como podemos enviar um novo código?</h1>
            </div>
            <div
              class="custom-control custom-radio form-control-lg text-left"
              v-if="email"
            >
              <input
                type="radio"
                id="email-validation-field"
                name="validationOption"
                class="custom-control-input"
                v-model="validationMethod"
                value="email"
              />
              <label class="custom-control-label" for="email-validation-field"
                >email {{ email.length > 25 ? email.substring(-1, 25)+'...' : email }}</label
              >
            </div>
            <div
              class="custom-control custom-radio form-control-lg text-left"
              v-if="celular"
            >
              <input
                type="radio"
                id="sms-validation-field"
                name="validationOption"
                class="custom-control-input"
                v-model="validationMethod"
                value="sms"
              />
              <label class="custom-control-label" for="sms-validation-field"
                >sms {{ celular }}</label
              >
            </div>
          </div>
          <div class="row">
            <div class="col">
              <g-recaptcha
                data-sitekey="6LcQB_EUAAAAAPGeh3IGuaY5gWca1ig2BzQOsODm"
                :data-validate="validate"
                :data-callback="sendCode"
                data-btn-class="btn mt-4 btn-lg btn-primary button success"
                id="sendButton"
              >
                Enviar código de verificação
              </g-recaptcha>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ValidacaoMixins from "@/mixins/validacao.mixins.js";
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";

export default {
  name: "EscolhaDeMetodo",
  mixins: [ValidacaoMixins],
  data: () => ({
    validationMethod: "",
  }),
  props: ["tipoDeUsuario", "indiceDependente"],
  mounted() {
    const flagPermiteEmail = JSON.parse(
      sessionStorage.getItem("flagPermiteEmail")
    );
    const flagPermiteSms = JSON.parse(sessionStorage.getItem("flagPermiteSms"));

    if (!flagPermiteEmail) this.email = null;
    if (!flagPermiteSms) this.celular = null;

    this.$nextTick(function() {
      if (!this.celular) {
        this.validationMethod = "email";
      } else if (!this.email) {
        this.validationMethod = "sms";
      }
    });
  },
  components: { gRecaptcha },
  computed: {
    titular() {
      return this.tipoDeUsuario === 'titular';
    },
    validationAddress() {
      if (!this.validationMethod) return null;
      if (this.validationMethod === "email") return this.email;
      return this.celular;
    },
    validationMethodText() {
      if (this.validationMethod === "email") return "e-mail";
      return "celular";
    },
    idDependente() {
      if (this.indiceDependente === undefined) return null
      const dependentes = JSON.parse(sessionStorage.getItem("dependentes"));
      const dependente = dependentes[parseInt(this.indiceDependente)];
      return dependente.idDependente;
    }
  },
  methods: {
    validate() {
      const isValid = Boolean(this.validationMethod.length)
      if (!isValid) {
        this.$notify({
          group: "mensagens",
          type: "error",
          text: 'Selecione uma das opções de validação.',
        });
      }
      return isValid
    },
    sendCode(captcha) {
      this.sendValidationCode(this.validationMethod, captcha)
        .then(() => {
          let path = "/verificar-codigo-de-validacao-da-conta/"+ this.tipoDeUsuario
          if (this.tipoDeUsuario === "dependente") {
            path = `${path}/${this.indiceDependente}`
          }
          this.$router.push({
            path,
            query: {
              validationMethod: this.validationMethod,
            },
          });
        })
        .catch((error) => {
          this.$notify({
            group: "mensagens",
            text:
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.msg) ||
              `Ocorreu um erro ao enviar o código`,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
form,
button {
  margin: auto;
}
.custom-radio * {
  cursor: pointer;
}
</style>
